'use strict';

exports.__esModule = true;
// Spacing-Helper (Welle 2b 2026-06, Option B): WERT-basiert + Skala = echter App-
// Rhythmus. Vorher index-basiert (space(5) -> 20px, 4/8-Grid); jetzt gibt der
// Zahlenwert direkt den px-Wert zurueck (space(10) -> '10px'), damit ALLE Bestands-
// abstaende render-neutral tokenisierbar sind (Thomas-Entscheid: volle Tokenisierung
// vor 4/8-Reinheit — die App laeuft real auf 5/10/15/20/25/30, nicht auf 4/8). 0 = ex-
// pliziter Reset ('0'). `theme.space` ist ein OPTIONALER Override-Hook (Default undef.
// -> '${v}px'); spaeter koennte space(10) zentral z.B. zu 8px retuned werden, ohne die
// ~552 Aufrufstellen anzufassen. SPACE_STEPS = dokumentierte Allowlist der real
// vorkommenden Stufen (NICHT erzwungen — Off-Scale-Werte werden trotzdem render-neutral
// durchgereicht, damit eine Migration nie ein Layout bricht).
//   padding: ${space(10, 15)};  ->  '10px 15px'
//   margin:  ${space(20)};      ->  '20px'
//   padding: ${space(0, 16)};   ->  '0 16px'   (0 = Reset, kein px)

var SPACE_STEPS = exports.SPACE_STEPS = [2, 4, 5, 6, 7, 8, 10, 12, 14, 15, 16, 18, 20, 22, 24, 25, 26, 30, 32, 34, 40, 42, 46, 48, 50, 60, 70, 80, 90];

var resolve = function resolve(theme, value) {
  if (value === 0 || value === '0') return '0';
  // `in`-Check statt `||`, damit ein Override-Wert wie '0' (falsy) nicht versehentlich
  // auf `${value}px` durchfaellt. Default (kein theme.space) -> render-neutral `${v}px`.
  if (theme && theme.space && value in theme.space) return theme.space[value];
  return value + 'px';
};

// space(...values) -> ({ theme }) => 'v1px v2px ...' (CSS-Shorthand-tauglich, theme-sicher).
var space = exports.space = function space() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        theme = _ref.theme;

    return values.map(function (v) {
      return resolve(theme, v);
    }).join(' ');
  };
};

exports.default = space;